import { Component } from '@angular/core';
import { CommonSharedModule } from '../common/shared.module';
import { PaymentProfilesCountComponent } from './profiles-count/payment-profiles-count.component';
import { PaymentAllProfilesComponent } from './all-profiles/payment-all-profiles.component';

@Component({
  selector: 'app-payment-profile',
  templateUrl: './payment-profiles.component.html',
  styleUrls: ['./payment-profiles.component.scss'],
  standalone: true,
  imports: [
    CommonSharedModule,
    PaymentProfilesCountComponent,
    PaymentAllProfilesComponent
  ]
})
export class PaymentProfilesComponent {}
